import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const RedirectOnReload: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const previousPathname = useRef(location.pathname); // Mantiene el historial previo

  useEffect(() => {
    // Verifica si la página ha sido recargada
    const isReloaded = localStorage.getItem('isReloaded');

    if (isReloaded) {
      localStorage.removeItem('isReloaded');
      navigate('/');
    }

    // Configura un listener para el evento beforeunload para marcar el estado de recarga
    const handleBeforeUnload = () => {
      localStorage.setItem('isReloaded', 'true');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [navigate]);

  useEffect(() => {  
    if (location.pathname === '/confirmation' && previousPathname.current === '/summary') {
      window.location.href = '/';
    }

    previousPathname.current = location.pathname;
  }, [location.pathname, navigate]);

  return null;
};

export default RedirectOnReload;
